import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useTypographyVariants } from '../../../materialConfig/customTypography';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .primary': {
      color: theme.palette.primary.main,
    },
    '& .primaryContrast': {
      color: theme.palette.primary.contrastText,
    },
    '& .bold': {
      fontWeight: 600,
    },
  },
}));

export type Variant =
  | 'h1'
  | 'h2'
  | 'h2m'
  | 'h3'
  | 'h3m'
  | 'h4'
  | 'text'
  | 'smallText'
  | 'textMedium'
  | 'caption'
  | 'tag'
  | 'custom';

type BaseTypographyProps = {
  variant?: Variant;
  className?: any;
  style?: any;
  textTransform?: any;
  onClick?: any;
  [key: string]: any;
};

export const BaseTypography: React.FC<BaseTypographyProps> = ({
  variant,
  className,
  ...props
}) => {
  const classes = useStyles();
  const tpVariants = useTypographyVariants();
  const { style = {}, textTransform = 'auto', ...otherProps } = props;
  return (
    <Typography
      className={clsx(variant && tpVariants[variant], classes.root, className)}
      style={{ ...style, textTransform }}
      {...otherProps}
    />
  );
};
